export default __webpack_public_path__ + "static/media/logo.83235e65.png";